import { EntityStatusInput, RemoveFormItem } from "@/components";
import { flattenMilestones, selectFilterHelper } from "@/helpers";
import { optionFieldType, optionType } from "@/propTypes";
import { useLazyGetProjectTemplatesByProjectTypeIdQuery } from "@/services";
import { Form, Input, Select, Space } from "antd";
import { arrayOf, bool, func, object } from "prop-types";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

export const OptionEditValue = ({
  field,
  remove,
  availableDependantValues,
  labelDisabled,
  isNew,
  formProperty,
}) => {
  const intl = useIntl();
  const isProjectTypeProperty =
    formProperty.property.label.fallback === "Project Type";
  let projectTypeId = null;
  const [fetchTemplateData] = useLazyGetProjectTemplatesByProjectTypeIdQuery({
    preferCache: false,
  });

  const validateProjectMilestoneActive = async (currField, inactiveRef) => {
    if (isProjectTypeProperty) {
      //validate the template, make sure we have exactly one project complete flag set before turning active
      projectTypeId = formProperty.values[currField?.key]?.UniqueIdentifier;
      if (projectTypeId) {
        var res = await fetchTemplateData(projectTypeId);
        var data = res?.data;
        if (!data?.milestones) {
          toast.error(
            intl.formatMessage({
              id: `entityStatusInput.noMilestones`,
            })
          );
          inactiveRef.current.input.click();
          return;
        }
        const milestones = flattenMilestones(data?.milestones);
        const closingMilestone = milestones.find(
          (milestone) =>
            milestone.shouldCompleteProject === true &&
            milestone.isActive === true
        );
        if (!closingMilestone) {
          toast.error(
            intl.formatMessage({
              id: `entityStatusInput.noProjectCompleteMilestone`,
            })
          );
          inactiveRef.current.input.click();
          return;
        }
      }
    }
  };

  return (
    <Space style={{ display: "flex", alignItems: "center" }}>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "label", "fallback"]}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.optionLabelRequired",
            }),
          },
        ]}
      >
        <Input
          disabled={labelDisabled}
          placeholder={intl.formatMessage({
            id: "newFormField.optionLabelPlaceholder",
          })}
        />
      </Form.Item>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "dependsOnPropertyValues"]}
      >
        <Select
          mode="multiple"
          style={{ maxWidth: 500, minWidth: 300 }}
          allowClear
          placeholder={intl.formatMessage({
            id: "newFormField.dependentValuesPlaceholder",
          })}
          filterOption={selectFilterHelper}
        >
          {availableDependantValues.map(({ value, text }) => (
            <Select.Option value={value} key={value}>
              {text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <EntityStatusInput
        parentComponent="option-edit-value"
        field={field}
        formProperty={formProperty}
        validateProjectMilestoneActive={validateProjectMilestoneActive}
        isNewProjectType={isNew && isProjectTypeProperty}
      />

      {!!isNew && (
        <RemoveFormItem
          parentComponent="option-edit-value"
          uniqueId={field.key}
          remove={() => remove(field.name)}
        />
      )}
    </Space>
  );
};

OptionEditValue.propTypes = {
  isNew: bool,
  labelDisabled: bool,
  remove: func,
  field: optionFieldType.isRequired,
  availableDependantValues: arrayOf(optionType).isRequired,
  formProperty: object,
};
